// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1989":"css/admin-app.6787","8123":"css/app.6787"}[chunkId] + ".css";
};